import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_78: FaireProductEntity = {
  token: "legacy_prod_abbott-78",
  type: "product",
  name: "Set of 3 Jumbo Straws with Marine Life Caps",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4e369af43676a8adb81628a1e1a13963cf77d3a60005ebc52c9b66a3e3fffeba.jpeg",
  priceDollars: 8,
  subcategory: "Tableware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_party-supplies"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
